import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Icon from 'flarum/common/components/Icon';
export default function addBestAnswerCountToUsers() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    // @ts-expect-error
    const user = this.attrs.user;
    items.add('best-answer-count', m("span", {
      className: "UserCard-bestAnswerCount"
    }, m(Icon, {
      name: "fas fa-check"
    }), app.translator.trans('fof-best-answer.forum.user.best-answer-count', {
      count: user.bestAnswerCount()
    })), 55);
  });
}